export default __webpack_public_path__ + "static/media/arrow.d053d7cb.svg";